import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppStateService } from './app-state.service';
import { ConfigStateService } from "./config-state.service";
import { DataProviderService } from "./data-provider.service";
import { ArticleDataService } from "./article-data.service";
import { AttributeDataService } from "./attribute-data.service";
import { ModelDataService } from "./model-data.service";
import { LangDataService } from './lang-data.service';
import { NavBarComponent } from 'app/core/nav-bar/nav-bar.component';
import { WebTrekkService } from './web-trekk.service';
import { PathService } from './path.service';
import { PdfGeneratorService } from './pdf-generator.service';
import { FormatterService } from './formatter.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        NavBarComponent
    ],
    exports: [
        NavBarComponent
    ],
    providers: [
        FormatterService
    ]
})
export class CoreModule {
    public static forRoot() {
        return {
            ngModule: CoreModule,
            providers: [
                AppStateService,
                PathService,
                ArticleDataService,
                DataProviderService,
                AttributeDataService,
                ModelDataService,
                LangDataService,
                WebTrekkService,
                PdfGeneratorService,
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts